<template>
	<v-container class="contact none-fluid link">
		<banner>Contact Information</banner>
		<br />
		<div class="mx-auto contact-content">
      <span v-html="this.robotics"></span>
    </div>
    <div style="margin-top:10pt; padding:0px">
      <span v-html="this.students"></span>
    </div>
    <div style="padding:0px">
      <span v-html="this.labTours"></span>
    </div>
    <div style="padding:0px">
      <span v-html="this.volunteers"></span>
    </div>
    <div style="padding:0px">
      <span v-html="this.angels"></span>
    </div>
    <div style="padding:0px">
      <span v-html="this.budgetContact"></span>
    </div>
    <div>
      <span v-html="this.contactInfo"></span>
    </div>
	</v-container>
</template>

<script>
import Banner from "../global/Banner";
import {getRobotics, getStudents, getLabTours, getVolunteers, getAngels, getBudgetContact, getContactInfo} from "../../service/contact";
// import "https://netdna.bootstrapcdn.com/bootstrap/3.0.0/css/bootstrap-glyphicons.css";

export default {
	components: {
		Banner
	},
	data() {
		return {
      robotics:"",
      students:"",
      labTours:"",
      volunteers:"",
      angels:"",
      budgetContact:"",
      contactInfo:""

		};
	},
	mounted() {
    getRobotics()
        .then(robotics => {
          this.robotics = robotics.content;
        })
        .catch(err => {
          console.error(err.message);
        });
    getStudents()
        .then(students => {
          this.students = students.content;
        })
        .catch(err => {
          console.error(err.message);
        });
    getLabTours()
        .then(labTours => {
          this.labTours = labTours.content;
        })
        .catch(err => {
          console.error(err.message);
        });
    getVolunteers()
        .then(volunteers => {
          this.volunteers = volunteers.content;
        })
        .catch(err => {
          console.error(err.message);
        });
    getAngels()
        .then(angels => {
          this.angels = angels.content;
        })
        .catch(err => {
          console.error(err.message);
        });
    getBudgetContact()
        .then(budgetContact => {
          this.budgetContact = budgetContact.content;
        })
        .catch(err => {
          console.error(err.message);
        });
    getContactInfo()
        .then(contactInfo => {
          this.contactInfo = contactInfo.content;
        })
        .catch(err => {
          console.error(err.message);
        });
  }
};
</script>

<style lang="scss">
.sub-sub-header{
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 20px;
  text-align: left;
  margin-bottom: 10px;
}
.contact {

  .icon{
    width:15px;
    margin:0px 25px;

	}
}

/**
 * following are responsive support
 */
@media (max-width: 420px) {
	.contact {
		.contact-content {
			.google-map {
				position: relative;
				width: 100% !important;
				height: 300px !important;
			}
		}
	}
}
</style>
